"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRentalFormProperties = class UcRentalFormProperties extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    editable;
    onEditable(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("editable");
    }
    rentalId;
    onRental_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rentalId");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_rental_property', { parameters: { rental_id: this.rentalId } });
    }
    ux;
    dataMembers = ['items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: {
                    initialLoadSpinner: true,
                },
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async evh_8320016629450276_close_9609_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_8320016629450276_showModal_9608_getActionArgs($event) {
        return {
            name: "RentalProperty",
            props: {
                rentalId: this.rentalId,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_6853569216922577_close_9613_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_6853569216922577_showModal_9612_getActionArgs($event) {
        return {
            name: "RentalProperty",
            props: {
                rentalId: this.rentalId,
                resourceId: $event.data.item.id,
            },
        };
    }
    async evh_6853569216922577_clickPreventStop(event, scope) {
        return await this.actions.evh_6853569216922577_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_6492569393195423_request_9616_getActionArgs($event) {
        return {
            operation: "delete_rental_property",
            data: { ...$event.data.prop, rental_id: this.rentalId },
        };
    }
    async act_6492569393195423_request_9616_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_6492569393195423_clickPreventStop(event, scope) {
        return await this.actions.evh_6492569393195423_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_9606 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_9605 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_9606,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_9605],
        });
        const act_8320016629450276_reloadComponentData_9610 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8320016629450276_close_9609 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_9610,
            event: "close",
            when: this.evh_8320016629450276_close_9609_getWhen,
            displayName: "reloadComponentData",
        });
        const act_8320016629450276_showModal_9608 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_9608_getActionArgs,
            events: [evh_8320016629450276_close_9609],
        });
        const evh_8320016629450276_clickPreventStop_9607 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_9608,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_9607],
        });
        const act_6853569216922577_reloadComponentData_9614 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6853569216922577_close_9613 = new core_1.actions.EventHandlerImpl({
            action: act_6853569216922577_reloadComponentData_9614,
            event: "close",
            when: this.evh_6853569216922577_close_9613_getWhen,
            displayName: "reloadComponentData",
        });
        const act_6853569216922577_showModal_9612 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6853569216922577_showModal_9612_getActionArgs,
            events: [evh_6853569216922577_close_9613],
        });
        const evh_6853569216922577_clickPreventStop_9611 = new core_1.actions.EventHandlerImpl({
            action: act_6853569216922577_showModal_9612,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_6853569216922577_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6853569216922577_clickPreventStop_9611],
        });
        const act_6492569393195423_reloadComponentData_9618 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6492569393195423_success_9617 = new core_1.actions.EventHandlerImpl({
            action: act_6492569393195423_reloadComponentData_9618,
            event: "success",
            displayName: "reloadComponentData",
        });
        const act_6492569393195423_request_9616 = new core_1.actions.RequestAction({
            actionArgs: this.act_6492569393195423_request_9616_getActionArgs,
            confirm: this.act_6492569393195423_request_9616_getConfirm,
            events: [evh_6492569393195423_success_9617],
        });
        const evh_6492569393195423_clickPreventStop_9615 = new core_1.actions.EventHandlerImpl({
            action: act_6492569393195423_request_9616,
            event: "click.prevent.stop",
            displayName: "request",
        });
        const evh_6492569393195423_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6492569393195423_clickPreventStop_9615],
        });
        return {
            act_7315092382398562_reloadComponentData_9606,
            evh_7315092382398562_reload_9605,
            evh_7315092382398562_reload,
            act_8320016629450276_reloadComponentData_9610,
            evh_8320016629450276_close_9609,
            act_8320016629450276_showModal_9608,
            evh_8320016629450276_clickPreventStop_9607,
            evh_8320016629450276_clickPreventStop,
            act_6853569216922577_reloadComponentData_9614,
            evh_6853569216922577_close_9613,
            act_6853569216922577_showModal_9612,
            evh_6853569216922577_clickPreventStop_9611,
            evh_6853569216922577_clickPreventStop,
            act_6492569393195423_reloadComponentData_9618,
            evh_6492569393195423_success_9617,
            act_6492569393195423_request_9616,
            evh_6492569393195423_clickPreventStop_9615,
            evh_6492569393195423_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: true,
    }),
    __metadata("design:type", Boolean)
], UcRentalFormProperties.prototype, "editable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editable'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalFormProperties.prototype, "onEditable", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcRentalFormProperties.prototype, "rentalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rentalId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalFormProperties.prototype, "onRental_id", null);
UcRentalFormProperties = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRentalFormProperties);
exports.default = UcRentalFormProperties;
vue_property_decorator_1.Vue.component("UcRentalFormProperties", UcRentalFormProperties);
